<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-no" id="part01">ACT I—</h2>
<h2 class="part-title">THE NEED FOR CREATIVE IDEAS</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?bffa7958